import clsx from "clsx";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./breadcrumb-pill.module.css";

interface BreadcrumbPillProps {
    href: string;
    title: string;
    onClick: () => void;
    iconName?: "cross-thin" | "plus-thin";
    iconPosition?: "before" | "after";
    hideIcon?: boolean;
}

function BreadcrumbPill({
    href,
    title,
    onClick,
    iconName = "cross-thin",
    iconPosition = "after",
    hideIcon,
}: BreadcrumbPillProps): null | JSX.Element {
    function handleClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        event.preventDefault();
        onClick();
    }
    return (
        <a
            role="button"
            href={href}
            onClick={handleClick}
            className={clsx(styles.pill, {
                [styles.pillIconBefore]: iconPosition === "before",
                [styles.pillWithoutIcon]: hideIcon,
            })}
        >
            <span>{title}</span>
            {!hideIcon && (
                <span className={styles.icon}>
                    <SVGIcon name={iconName} />
                </span>
            )}
        </a>
    );
}

export default BreadcrumbPill;
